import { Action } from '@ngrx/store';
import { UserState } from './user.state';

export const CHECKING			= '[User] Checking User';
export const CHECKING_SUCCESS 	= '[User] User is Logged';
export const CHECKING_FAIL 		= '[User] User is guest';
export const LOGIN_DONE 		= '[User] User is loged in';

export class Checking implements Action {
	readonly type = CHECKING;
}

export class CheckingSuccess implements Action {
	readonly type = CHECKING_SUCCESS;
	constructor(readonly payload: { name: string, sessionID: string }) { }
}

export class CheckingFail implements Action {
	readonly type = CHECKING_FAIL;
}

export class Login implements Action {
	readonly type = LOGIN_DONE;
	constructor(readonly payload: UserState) { }
}

export type Actions = Checking | CheckingSuccess | CheckingFail | Login;
